<template>
  <div
    class="LmLogo"
    :class="{'is-anim': animated}"
    :style="{width: size + 'px', height: size + 'px'}"
  >
    <svg viewBox="0 0 100 100">
      <circle
        v-for="c in circles"
        :key="c.name"
        class="Circle"
        :class="c.name"
        cx="50"
        cy="50"
        :r="c.radius"
        :stroke="c.color"
        :stroke-width="stroke"
        :stroke-dasharray="c.dash"
        :stroke-dashoffset="c.offset"
        :transform="c.rotation"
      ></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LmLogo',
  props: {
    size: {
      type: Number,
      default: 40
    },
    animated: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      viewBoxSize: 100,
      stroke: 6,
      colors: [
        '#018081',
        '#785d6c',
        '#f0a518',
        '#de432c',
        '#9ac9db',
        '#697c76',
        '#e45658'
      ],
      circles: [
        {
          name: 'CircleA',
          radius: 47, // (viewBoxSize/2) - (stroke/2)
          dash: 295, // 2 * PI * radiusA
          offset: 0,
          rotation: 'rotate(0)',
          color: '#000'
        },
        {
          name: 'CircleB',
          radius: 20,
          dash: 125,
          offset: 0,
          rotation: 'rotate(0)',
          color: '#000'
        }
      ]
    }
  },
  computed: {},
  created() {
    this.generateValues()
  },
  methods: {
    generateValues() {
      const c1 = this.circles[0]
      const c2 = this.circles[1]
      c1.offset = c1.dash * getRandom(0.2, 0.7)
      c2.offset = c2.dash * getRandom(0.15, 0.55)
      c1.rotation = `rotate(${getRandomInt(0, 360)})`
      c2.rotation = `rotate(${getRandomInt(0, 360)})`
      c1.color = this.colors[getRandomInt(0, 6)]
      c2.color = this.colors[getRandomInt(0, 6)]
    }
  }
}
function getRandom(min, max) {
  return Math.random() * (max - min) + min
}
function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}
</script>

<style>
.LmLogo {
  .Circle {
    fill: none;
    transform-origin: center center;
  }
  &.is-anim {
    .CircleA {
      animation: rotate 1s infinite linear;
    }
    .CircleB {
      animation: rotate-back 0.8s infinite linear;
    }
  }
}
</style>
